'use client';

import { HTMLAttributes } from 'react';
import { overlay, content, modalResponsiveContent } from './modal.css';
import { CloseIconUI } from '../close-icon/close-icon';
import { useDismissible } from '@instamenu/react-hooks';
import { useRouter } from 'next/navigation';
import { createPortal } from 'react-dom';
import clsx from 'clsx';

export type ModalNextProps = {
  containerStyle?: React.CSSProperties;
  onRequestClose?: () => void;
  returnPath?: string;
  withCloseButton?: boolean;
  closeOnBackgroundClick?: boolean;
  opened?: boolean;
  usePortal?: boolean;
  className?: string;
} & HTMLAttributes<HTMLDivElement>;

export const ModalNext = ({
  children,
  containerStyle,
  withCloseButton = true,
  onRequestClose,
  returnPath,
  closeOnBackgroundClick = true,
  opened = false,
  usePortal = true,
  className,
  ...rest
}: ModalNextProps) => {
  const router = useRouter();

  const { ref } = useDismissible<HTMLDivElement>(() => {
    if (closeOnBackgroundClick) {
      if (onRequestClose) onRequestClose();
      else if (returnPath) router.push(returnPath, { scroll: false });
      else router.back();
    }
  });

  if (!opened) return null;
  const modalContent = (
    <div className={overlay} data-id="modal-overlay">
      <div ref={ref} className={clsx(content, className)} style={containerStyle} {...rest}>
        {withCloseButton && <CloseIconUI path={onRequestClose} returnPath={returnPath} />}
        <div className={modalResponsiveContent}>{children}</div>
      </div>
    </div>
  );

  if (typeof document !== 'undefined' && usePortal) {
    return createPortal(modalContent, document.getElementById('restaurant-theme') || document.body);
  }

  return modalContent;
};
